import { BONUSES_ACTION_TYPES } from "./actionTypes";

const initialState = {
    loading: false,
    applying: false,
    error: null,

    info: null,

    coupon: null,
    isApplied: false,
    discount: 0,
    appliedCartTotal: 0,
    appliedAt: null,
};

export const bonusesReducer = (state = initialState, action) => {
    switch (action.type) {
        case BONUSES_ACTION_TYPES.FETCH_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }

        case BONUSES_ACTION_TYPES.FETCH_SUCCESS: {
            return {
                ...state,
                loading: false,
                info: action.payload,
            };
        }

        case BONUSES_ACTION_TYPES.FETCH_FAILURE: {
            return {
                ...state,
                loading: false,
            };
        }

        case BONUSES_ACTION_TYPES.APPLY_REQUEST: {
            return {
                ...state,
                applying: true,
                error: null,
            };
        }

        case BONUSES_ACTION_TYPES.APPLY_SUCCESS: {
            const { coupon, discount, cartTotal } = action.payload;

            return {
                ...state,
                applying: false,
                error: null,
                coupon: coupon,
                isApplied: true,
                discount: Number(discount) || 0,
                appliedCartTotal: Number(cartTotal) || 0,
                appliedAt: action.meta.timestamp,
            };
        }

        case BONUSES_ACTION_TYPES.APPLY_FAILURE: {
            return {
                ...state,
                applying: false,
                error: action.payload.error,
                isApplied: false,
            };
        }

        case BONUSES_ACTION_TYPES.CLEAR_POINTS: {
            return {
                ...state,
                coupon: null,
                isApplied: false,
                discount: 0,
                appliedCartTotal: 0,
                appliedAt: null,
                error: null,
            };
        }

        default:
            return state;
    }
};
